import { environment } from '@environments/environment';
import { LogElement } from '@models/order';

export class OrderDocument {
  static printImages(
    images: any[] | null | undefined,
    token: string,
    imageBase: string = `${environment.base_url}/image/`
  ): void {
    const ids = (images || []).filter((id) => !!id);
    if (!ids.length) {
      window.print();
      return;
    }

    let html =
      '<html><style type="text/css" media="print">@media screen { @page {size: A4 portrait; } html { width:8.5in; height:11in; margin: 0 0 0 0;} body{margin: 0 0 0 0;} img{display: block; max-height:9in;page-break-inside: avoid;}</style><script type="text/javascript">setTimeout(function () { window.print(); }, 500);window.onfocus = function () { setTimeout(function () { window.close(); }, 500); }</script><body style="width:100%;"><div style="width:100%;text-align:center;">';
    ids.forEach((id) => {
      html +=
        '<img src="' +
        imageBase +
        id +
        '/thumbnail/0?bearer=' +
        token +
        '" style="max-height:9in">';
    });
    html += '</div></body></html>';
    const WindowPrt = window.open(
      '',
      '',
      'left=0,top=0,width=900,height=900,toolbar=0,scrollbars=0,status=0'
    );
    if (!WindowPrt) {
      window.print();
      return;
    }
    WindowPrt.document.write(html);
    WindowPrt.document.close();
  }

  static isValidEmail(email: string): boolean {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(email || '').trim());
  }

  static openMailto(email: string, invoiceNumber: string, storeName?: string): void {
    const to = String(email || '').trim();
    const invoice = String(invoiceNumber || '').trim() || 'your order';
    const from = String(storeName || '').trim();
    const subject = encodeURIComponent(
      from ? `Invoice ${invoice} from ${from}` : `Invoice ${invoice}`
    );
    const body = encodeURIComponent(
      `Please find a copy of your completed invoice ${invoice}.`
    );
    window.location.href = `mailto:${encodeURIComponent(to)}?subject=${subject}&body=${body}`;
  }

  static emailLogItem(initials: string, userId: string, email: string): LogElement {
    const logItem = new LogElement();
    logItem.initials = initials;
    logItem.user = userId;
    logItem.item = 'Invoice emailed to customer';
    logItem.notes = String(email || '').trim();
    logItem.date = Date.now().toString();
    return logItem;
  }
}
